import React, {KeyboardEvent} from 'react';
import {Collapse, List} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  CalendarToday,
  Notifications,
  People,
  AssignmentTurnedIn,
  Publish,
  FileOpen,
  RuleFolder,
} from '@mui/icons-material';
import MenuItem from '../MenuItem/MenuItem';
import {ExpandedPanel, Header} from '../SideMenu/SideMenu';
import {useSideMenuStyles} from '../SideMenu/styles';
import {SaltusAny} from '../../utils/SaltusAny';

type ReviewMenuItemProps = {
  pathname: string;
  expanded: boolean;
  handleChange: React.Dispatch<React.SetStateAction<ExpandedPanel>>;
};

type MenuItemData = {
  href: string;
  icon: React.FC<{[key: string]: SaltusAny}>;
  label: string;
};

const menuItemsData: MenuItemData[] = [
  {href: '/reviews/PLANNED', icon: () => <Notifications />, label: 'Planned'},
  {
    href: '/reviews/MEETING_BOOKED',
    icon: () => <CalendarToday />,
    label: 'Meeting Booked',
  },
  {href: '/reviews/AWAITING_EHONS', icon: () => <People />, label: 'Awaiting EHONS'},
  {href: '/reviews/SOFT_SUBMITTED', icon: () => <Publish />, label: 'Soft Submitted'},
  {href: '/reviews/OPEN', icon: () => <FileOpen />, label: 'Open'},
  {href: '/reviews/COMPLETED', icon: () => <AssignmentTurnedIn />, label: 'Completed'},
  {href: '/reviews/CLOSED', icon: () => <RuleFolder />, label: 'Closed'},
];

const ReviewMenuItem = ({pathname, expanded, handleChange}: ReviewMenuItemProps) => {
  const classes = useSideMenuStyles();
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleChange((e) => (e ? null : 'reviews'));
    }
  };

  return (
    <>
      <div
        onClick={() => handleChange((e) => (e === 'reviews' ? null : 'reviews'))}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        style={{
          ...classes.accordionSummary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <Header sx={{fontSize: 12}}>My Reviews</Header>
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {menuItemsData.map((item) => (
            <MenuItem
              key={item.label}
              href={item.href}
              icon={item.icon}
              label={item.label}
              pathname={pathname}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default ReviewMenuItem;
